import { useDispatch, useSelector } from "react-redux";
import CourseCardComponentB2c from "./CourseCardComponentB2c";
import { useCallback, useEffect, useState } from "react";
import { getProductCategories } from "../../redux/courses/actions";
import { SessionKeys, getStepIndex } from "../../utils/AppUtils";
import _ from "lodash";
import Loader from "../Loader/Loader";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
// import FilterAndSearchSection from "./FilterAndSearchSection";
import CourseListingMainComponent from "./CourseListingMainComponent";
import LPListingContentComponent from "../NewDesign/ListingContent/LPListingContent/LPListingContentComponent";
import useLogin from "../../custom-hooks/useLogin";
import { useNavigate } from "react-router-dom";
import NewCourseListingMainComponent from "./NewCourseListingMainComponent";
import { setJoyRideReq } from "../../redux/assignCourse/actions";
import CourseComboMainComponent from "./CourseComboMainComponent";
import { useTranslation } from "react-i18next";
const CourseListComboComp = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoggedIn, userData } = useLogin()
    const userRole = useSelector((state) => state.user.role);
    const authBroker = useSelector((state) => state.auth.authBroker);
    const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
    const {t} = useTranslation();

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const c = params.get("c");
    let providerId = "";
    if (c) {
        let decodedString = atob(c);
        let paramsReq = JSON.parse(decodedString);
        providerId = paramsReq.provider_id;
    }
    // const providerId = params.get("provider_id");

    const showMyOnboard = useCallback(() => {
        if (!_.isEmpty(userData.role)) {
            console.log(userData.role)
            if (!userData.role.includes('customer')) return true;
        }
        return false
    }, [userData])

    const renderCourseComp = () => {
        return (
            <CourseComboMainComponent
                tabKey={"combo"} 
                isCombo={true}/>
        )
    }

    useEffect(() => {
        window.scrollTo(0,0);
       
    }, []);


return (
    <>
    <div className="contsection">

        <nav>
            <div className="nav-section-box" id="nav-tab" role="tablist">
                <Tabs
                    underline
                    activeKey={'ComboCourses'}
                    onSelect={(k) => {
                    }}
                >
                    <Tab eventKey={'ComboCourses'} title={t("combo&Offers")}>
                    {renderCourseComp()}
                    </Tab>
                </Tabs>

            </div>
        </nav>


    </div>
</>
    )

}
export default CourseListComboComp;